import { SraPassFailFormula } from './P81.formulas';

export const TestResultSectionDataP81 = (selectedTag, formData) => ({
    rows: [
        {
            key: 1,
            fields: [
                {
                    key: 'NoData1',
                    isLabel: true,
                    xs: 4
                },
                {
                    key: 'F334SraPassFailLabel',
                    label: 'SRA PASS/FAIL',
                    xs: 2,
                    labelWidth: '96%',
                    fontWeight: 600,
                    fontSize: '9pt',
                    textAlign: 'end',
                    padding: '5px 0 0 0',
                    isLabel: true
                },
                {
                    key: 'F334SraPassFail',
                    value: SraPassFailFormula(formData),
                    readOnly: true,
                    isCalculatedNew: true,
                    xs: 2,
                    labelWidth: '0',
                    width: '91%',
                    textAlign: 'center',
                }
            ]
        },

    ]
});
